import { DLOBreadcrumbItem } from '../../../components/DLOBreadcrumb';

export const DAY_MAPPING = {
  1: 'sun', 
  2: 'mon', 
  3: 'tue', 
  4: 'wed', 
  5: 'thu', 
  6: 'fri', 
  7: 'sat'
} as const;

export const createBreadcrumbItems = (onNavigate?: (screen: string) => void): DLOBreadcrumbItem[] => [
  {
    id: 'labor-optimization',
    label: 'Labor Optimization',
    onPress: () => {
      console.log('Breadcrumb: Navigate to Labor Optimization');
      onNavigate?.('DLODashboard');
    }
  },
  {
    id: 'location-settings',
    label: 'Location Settings',
    isCurrentPage: true
  }
];

export const DEFAULT_PERCENTAGE_VALUES = {
  sun: { default: '0.00%', override: '0.00%' },
  mon: { default: '0.00%', override: '0.00%' },
  tue: { default: '0.00%', override: '0.00%' },
  wed: { default: '0.00%', override: '0.00%' },
  thu: { default: '0.00%', override: '0.00%' },
  fri: { default: '0.00%', override: '0.00%' },
  sat: { default: '0.00%', override: '0.00%' },
};
